import { Flex, Typography } from '@iheartjane/reefer';
import type { MarginProperties } from '@iheartjane/reefer';

import { MENU_PRODUCT_SPONSORED_HEIGHT } from '../legacyMenuProductCard/utils/productCardHelper';

interface SponsoredTagProps extends MarginProperties {
  hideText?: boolean;
}

export const SponsoredTag = ({
  hideText = false,
  ...spacingProps
}: SponsoredTagProps) => (
  <Flex height={MENU_PRODUCT_SPONSORED_HEIGHT} justifyContent="center">
    {!hideText && <SponsoredText {...spacingProps} />}
  </Flex>
);

export const SponsoredText = (spacingProps: MarginProperties) => (
  <Typography variant="mini" color="text-light" {...spacingProps}>
    Sponsored
  </Typography>
);
